import { useRef } from 'react';
import { RichTextPreviewFormData } from './contracts';
import { useXEmbeds } from '../../../utils/useXEmbeds';

export type RichTextPreviewProps = RichTextPreviewFormData;

export const RichTextPreview = ({ content }: RichTextPreviewFormData) => {
  const contentRef = useRef<HTMLDivElement>(null);
  useXEmbeds(contentRef, content);

  return (
    <div
      ref={contentRef}
      className="richTextPreview"
      style={{ width: '100%' }}
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
};
